import { IApplicationState } from '../../types/redux';
import { getIsAgent } from '../user';

export const getIsBrokerBannerAvailable = (state: IApplicationState) => {
  const isNewbuildingBrokerEnabled = state.config.isNewbuildingBrokerEnabled;
  const isAgent = getIsAgent(state);

  return isNewbuildingBrokerEnabled && isAgent;
};
